<template>
  <div class="home">
    <div>
      <img :src="info.productImg">
      <p class="title">{{ info.productName }}</p>
      <div :key="componentKey">

        <div class="lineBox" v-if="info.cups.length !== 0">
          <span class="lineName">杯型</span>
          <div class="valueBox">
            <div v-for="item in info.cups" :key="item.specId"
                 :class='["valueName",item.isSelected ===1 ? "isSelected" :""]'
                 @click="changeCup(item)">
              {{ item.specName }}
            </div>
          </div>
        </div>

        <div v-for="item in productAttrs" :key="item.attributeId" class="lineBox">
          <span class="lineName">{{ item.attributeName }}</span>
          <div class="valueBox">
            <div v-for="son in item.productAttrs" :key="son.attributeId"
                 :class='["valueName",son.isSelected ===1 ? "isSelected" :""]'
                 @click="changeSku(item,son)">
              {{ son.attributeName }}
            </div>
          </div>
        </div>

      </div>

      <div style="width: 80%;margin: 20px auto">
        <el-button style="width: 100%;background-color: #E60012;border-color:#E60012;" type="primary"
                   @click="dialogVisible = true">立即下单
        </el-button>
      </div>
    </div>


    <el-dialog
        :visible.sync="dialogVisible"
        title="确认下单"
        width="80%">
      <div class="sureInfo">
        <div style="display: flex">
          <p>下单店铺：</p>
          <p>{{ shopInfo.shopName }}</p>
        </div>
        <div style="display: flex">
          <p>下单商品：</p>
          <p>{{ info.productName }}</p>
        </div>

        <div style="display: flex" v-if="temperature.attributeName">
          <p>下单规格：</p>
          <p>{{ selectedAttributesText }}</p>
        </div>

        <div style="display: flex;align-items: center">
          <p>下单备注：</p>
          <el-input v-model="remark" :rows="2" placeholder="请输入备注" type="textarea"></el-input>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="toOrder()">确 定</el-button>
  </span>
    </el-dialog>



    <el-dialog
        :visible.sync="showDialog"
        title="下单中"
        width="60%"
        :close-on-click-modal="false"
    >
      <span>{{loadingText}}</span>
      <template #footer>
        <el-button
            type="primary"
            @click="closeProcessingDialog"
            :loading="loading"
        >
          {{ loading ? '处理中...' : '确认' }}
        </el-button>
      </template>
    </el-dialog>


    <el-button v-if="admin==='ADC'" style="width: 100%;background-color: #E60012;border-color:#E60012;" type="primary"
               @click="getOrderInfo()">获取下单信息
    </el-button>


  </div>
</template>

<script>
import {update, updateADC, updateCard, updateTOP} from '../api/mxbc'

export default {
  name: 'ProductView',
  
  data() {
    return {
      shopInfo: {},
      info: {},
      productAttrs: [],
      cups:[],
      cup:{},
      temperature: {},
      sugar: {},
      type:1,
      componentKey: 0,
      dialogVisible: false,
      remark: '',
      showDialog: false,
      loading: true,
      loadingText: '正在下单中，请稍等',
      orderFlag: false,
      admin:''
    }
  },

  computed: {
    hasCustomAttributes() {
      return this.temperature.attributeName && this.sugar.attributeName
    },

    selectedAttributesText() {
      //if (!this.hasCustomAttributes) return ''
      //return `${this.temperature.attributeName}/${this.sugar.attributeName}`
      let text = this.cup.length !== 0 ? `${this.cup.specName}` : ''
      const productAttrs = this.productAttrs
      productAttrs.forEach(attr => {
        attr.productAttrs.forEach((option) => {
          if (option.isSelected === 1) {
            let ad = text ? `/${option.attributeName}` : option.attributeName
            text = text + ad
          }
        })
      })
      return text
    },

    orderParams() {
      return {
        shopID: this.shopInfo.shopID,
        productID: this.info.productId,
        modifiedTime: this.info.modifiedTime,
        temperature: this.temperature.attributeId || "",
        sugar: this.sugar.attributeId || "",
        cupId: this.cup.specId || "",
        cardID: localStorage.getItem('cardID'),
        remark: this.remark,
        type: this.type
      }
    }
  },

  created() {
    this.initializeData()
  },

  methods: {
    initializeData() {
      // Initialize card ID if present in route
      if (this.$route.query.cardID) {
        const cardID = this.$route.query.cardID
        localStorage.setItem('cardID', cardID)
      }

      // Load product and shop info
      this.info = JSON.parse(localStorage.getItem('itemInfo'))
      this.shopInfo = JSON.parse(localStorage.getItem('shopInfo'))
      this.type = localStorage.getItem('type')

      if (localStorage.getItem('admin')){
        this.admin = localStorage.getItem('admin')
      }
      // Initialize product attributes
      this.initializeProductAttributes()
    },

    initializeProductAttributes() {
      const productAttrs = this.info.productAttrs
      const cups = this.info.cups

      productAttrs.forEach(attr => {
        attr.productAttrs.forEach((option, index) => {
          option.isSelected = index === 0 ? 1 : 0
        })
      })


        cups.forEach((option, index) => {
          option.isSelected = index === 0 ? 1 : 0
        })


      this.productAttrs = productAttrs
      this.cups = cups
      this.temperature = productAttrs[0]?.productAttrs[0] || {}
      this.sugar = productAttrs[1]?.productAttrs[0] || {}
      this.cup = cups[0] || []
    },

    changeSku(attribute, selectedOption) {
      // Update temperature or sugar based on attribute type
      if (attribute.attributeName === '温度') {
        this.temperature = selectedOption
      } else if (attribute.attributeName === '糖度') {
        this.sugar = selectedOption
      }

      // Update selection status in productAttrs
      this.productAttrs = this.productAttrs.map(attr => {
        if (attr.attributeName === attribute.attributeName) {
          attr.productAttrs = attr.productAttrs.map(option => ({
            ...option,
            isSelected: option.attributeName === selectedOption.attributeName ? 1 : 0
          }))
        }
        return attr
      })

      // Force re-render of attributes section
      this.componentKey += 1
    },
    changeCup(item){
      if(item.specPrice > 700 && this.type == 4) return this.$message.error('超过7元，暂不可选')
      this.cup = item
      this.cups = this.cups.map(attr => {
        attr.isSelected = attr.specName === item.specName ? 1 : 0
        return attr
      })

      // Force re-render of attributes section
      this.componentKey += 1
    },

    closeProcessingDialog() {
      if (!this.loading) {
        this.showDialog = false
      }
      if (this.loadingText.includes("已下单，未支付")) return this.$router.push('/orderList')
      if (this.loadingText.includes("下单成功")) return this.$router.push('/order')
    },

    async toOrder() {
      const value = JSON.parse(localStorage.getItem('value'))
      if (value.code !== 0) {
        this.$message.error(value.msg)
        return
      }

      if (this.orderFlag) return
      this.loadingText = '正在下单中，请稍等'
      this.orderFlag = true
      this.showDialog = true

      try {
        const type = Number(localStorage.getItem('type'))
        //const apiCall = type === 1 || type === 4 ? update : updateADC
        //const apiCall = updateTOP
        let res;
        if (type == 10){
          res = await updateCard(this.orderParams)
        }else{
          res = await updateTOP(this.orderParams)
        }
        
        this.handleOrderResponse(res)
      } catch (error) {
        this.handleOrderError()
      } finally {
        this.cleanupOrder()
      }
    },

    handleOrderResponse(res) {
      if (res.code !== 0) {
        this.loadingText = res.msg
        return
      }
      localStorage.removeItem('orderID')
      const value = { code: 1, msg: "已下单" }
      localStorage.setItem('value', JSON.stringify(value))

      if (res.data){
        window.location.href=res.data
        return;
      }
      
      this.loadingText = '下单成功，请前往取餐码页面查看'
      this.$message.success('下单成功，请前往取餐码页面查看')
    },

    handleOrderError() {
      this.loadingText = '下单失败，请联系管理员'
      this.$message.error('下单失败，请联系管理员')
    },

    cleanupOrder() {
      this.loading = false
      this.dialogVisible = false
      this.orderFlag = false
    },

    getOrderInfo(){
      console.log(this.orderParams,'下单信息')
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  margin-bottom: 80px;

  img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  .title {
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
  }

  .skuItem {
    margin: 10px 0;
    padding: 6px 13px;
    border: 1px solid #F6E9EB;
    border-radius: 5px;
  }

  .isSelected {
    //border-color: #E60012;
    background-color: #F6E9EB;
    color: #E60012;
  }

  .sureInfo {
    font-size: 15px;

    p {
      min-width: 80px;
    }

    div:nth-child(2) {
      margin: 20px 0;
    }

  }

  /deep/ .el-dialog {
    margin-top: 30vh !important;
  }

  .el-button--primary {
    background-color: #E60012;
    border-color: #E60012;
  }

  //.search{
  //  width: 80%;
  //  margin: 50px auto 0 auto;
  //  display: flex;
  //  .search-ipt{
  //    margin-right: 20px;
  //  }
  //}
  //.choseDrink{
  //  width: 80%;
  //  margin: 20px auto 0 auto;
  //}
  //.drinkBox{
  //  margin-top: 20px;
  //  width: 100%;
  //  img{
  //    width: 100%;
  //  }
  .lineBox {
    display: flex;
    //align-items: center;
    padding: 10px 20px 0 20px;

    .lineName {
      font-size: 16px;
      font-weight: 200;
      min-width: 50px;
      line-height: 31px;
      margin: 10px 0 0 0;
    }

    .valueBox {
      display: flex;
      flex-wrap: wrap;

      .valueName {
        //color: #999999;
        min-width: 58px;
        font-size: 14px;
        font-weight: 200;
        text-align: center;
        //border: 1px solid #999999;
        border: 1px solid #000000;
        border-radius: 5px;
        //background-color: #F1F1F1;
        padding: 10px 13px;
        margin: 10px 20px 0 0;
      }

      .noShow {
        display: none;
      }

      .isSelected {
        //border-color: #989898;
        background-color: #FFF7F8;
        color: #E60012;
      }
    }

  }

  //
  //  .sku{
  //    font-size: 14px;
  //    font-weight: 100;
  //    margin: 10px 20px;
  //  }
  //}
}
</style>
